import { login, loginByAuthcode } from '@/api/ProfileApi';
import { setAuthority } from '@/auth/authority';
import { reloadAuthorized } from '@/auth/Authorized';
import { setProfile, setToken, setSystemCode } from '@/tool/profile';

import {
  PROFILE_LOGIN_REQUEST,
  PROFILE_LOGIN_SUCCESS,
  PROFILE_LOGIN_FAILURE,
  PROFILE_AVATAR_UPDATE,
  PROFILE_MESSAGE_UPDATE,
  PROFILE_QRURL_UPDATE,
  PROFILE_QRENABLED_UPDATE,
} from '../constants/ProfileConstants';

function loginRequest() {
  return {
    type: PROFILE_LOGIN_REQUEST,
    isLoading: true,
  };
}

export function loginSuccess(result) {
  return {
    type: PROFILE_LOGIN_SUCCESS,
    payload: result,
    isLoading: false,
  };
}

function loginFailure() {
  return {
    type: PROFILE_LOGIN_FAILURE,
    isLoading: false,
  };
}

export function updateAvatar(avatar) {
  return {
    type: PROFILE_AVATAR_UPDATE,
    payload: avatar,
  };
}

export function updateMessages(messages) {
  return {
    type: PROFILE_MESSAGE_UPDATE,
    payload: messages,
  };
}

export function updateQRUrl(qrUrl) {
  return {
    type: PROFILE_QRURL_UPDATE,
    payload: qrUrl,
  };
}

export function updateQREnabled(enabled) {
  return {
    type: PROFILE_QRENABLED_UPDATE,
    payload: enabled,
  };
}

// TODO: 把逻辑写在action里面，好吗？
export function doLogin(params) {
  const { username, userpwd, captcha, uuid, remember, captchable = true, companycode } = params;
  return async dispatch => {
    dispatch(loginRequest());
    try {
      // 也可以用promise代替
      const result = await login(username, userpwd, captcha, uuid, captchable, companycode);
      // console.log(result);
      // var savedProfile = {
      //     userid: result.userid,
      //     username: result.username,
      //     deptid: result.dept ? result.dept.deptid : 0,
      //     //TODO: 根部门需不需要重新命名一下;
      //     deptname: result.dept ? result.dept.deptname : '超级部门',
      //     remember: remember,
      // }
      // if (remember) {
      //     Object.assign(savedProfile, { password: result.userpwd })
      // }
      // setProfile(savedProfile);
      // setToken(result.token);
      // setAuthority(result.permissions);
      // reloadAuthorized();
      // Feedback.toast.success('登录成功！');
      // dispatch(loginSuccess(savedProfile));

      const { token, permissions, syscode, regcode, ...basicProfile } = result;
      // TODO: 目前密码用的字段名称是userpwd，因为后台是这么返回的，是否修正一下？
      Object.assign(basicProfile, { remember, userpwd: remember ? userpwd : '' });

      setProfile(basicProfile);
      setToken(token);
      // setAuthority(permissions);
      // 分为用户权限和访客权限，用于实现访客对相关界面和操作的限制
      // TODO: 是否直接放在接口返回更好？
      setAuthority(`${permissions},${username === 'guest' ? 'guest' : 'user'}`);
      // if (syscode && regcode) {
      // WM HM都用同一个方法保存系统码，区别是WM只有syscode，HM两者都有
      setSystemCode(syscode, regcode);
      // }
      reloadAuthorized();
      // Feedback.toast.success('登录成功！');
      dispatch(loginSuccess(basicProfile));

      return result;
    } catch (err) {
      dispatch(loginFailure());
      throw err;
      // 异常已经在网络请求库中进行了统一的捕获;
      // if (err) {
      //     if (err.resultCode == 10001) Feedback.toast.error('登录失败，用户名错误...');
      //     else if (err.resultCode == 10002) Feedback.toast.error('登录失败，密码不对...');
      //     else    Feedback.toast.error('未知错误...'+err);
      // }
      // dispatch(loginFailure());
      // return null;
    }
  };
}

// 授权登录，用于简单集成登录，默认以admin身份登录系统
export function doAuthLogin(params) {
  const { authCode } = params;
  return async dispatch => {
    dispatch(loginRequest());
    try {
      // 也可以用promise代替
      const result = await loginByAuthcode(authCode);
      // console.log(result);
      const { token, permissions, syscode, regcode, ...basicProfile } = result;
      setProfile(basicProfile);
      setToken(token);
      // setAuthority(permissions);
      // 分为用户权限和访客权限，用于实现访客对相关界面和操作的限制
      setAuthority(`${permissions},user`);
      // WM HM都用同一个方法保存系统码，区别是WM只有syscode，HM两者都有
      setSystemCode(syscode, regcode);
      reloadAuthorized();
      // Feedback.toast.success('登录成功！');
      dispatch(loginSuccess(basicProfile));
      return result;
    } catch (err) {
      dispatch(loginFailure());
      throw err;
    }
  };
}
